import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { byName } from '../../../branches/data/datasources/branch-shape';

/** `GET /client/:cid/regions`, in name order. */
export const getRegions = async (): Promise<any[]> => {
  const regions = await lpRequest('GET', clientPath('/regions'));

  return (regions || []).sort(byName);
};
